import React from 'react';
import { EnumDropdown, EnumDropdownProps } from 'framework/form';
import { EDUCATION_OPTIONS } from './educationConstants';

const EducationTypeInput = (props: Omit<EnumDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={EDUCATION_OPTIONS} />;
};

export default EducationTypeInput;
